import React from 'react';
import { Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const DASHBOARD_FAST_WORKERS_URL = 'https://dashboard.sogni.ai/fast-workers';

const FastWorkersMovedView = ({ account }) => {
  const location = useLocation();
  const nftId = new URLSearchParams(location.search).get('nftId');
  const hasWalletAddress = /^0x[a-fA-F0-9]{40}$/.test(account || '');
  const hasNftId = /^\d+$/.test(nftId || '');

  const destination =
    hasWalletAddress && hasNftId
      ? `${DASHBOARD_FAST_WORKERS_URL}/${account}/${nftId}`
      : DASHBOARD_FAST_WORKERS_URL;

  return (
    <div
      style={{
        maxWidth: '720px',
        margin: '3rem auto',
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
      }}
    >
      <h2 style={{ color: '#9fef00', marginBottom: '1rem' }}>
        My Fast Workers has moved
      </h2>
      <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
        Fast Worker details and performance analytics are now available in the
        Sogni Dashboard.
      </p>
      <Button
        as="a"
        href={destination}
        variant="success"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open My Fast Workers in Sogni Dashboard
      </Button>
    </div>
  );
};

export default FastWorkersMovedView;
